<template>
  <v-dialog width="350px" persistent v-model="editDialog" class="editDialogsRow">
    <v-card-text class="pa-0" slot="activator">
      Add Investigator
      <v-icon class="text-xs-right">add</v-icon>
    </v-card-text>
    <v-card>
      <v-container>
        <v-layout justify-end row wrap>
          <v-flex xs1 class="mb-2">
            <v-icon depressed class="cyan--text text--lighten-1" @click="editDialog = false">close</v-icon>
          </v-flex>
          <v-flex xs12 class="mb-2">
            <v-card-title class="text-xs-center justify-center"><h2>Edit {{ trial.trialName }} Investigators</h2></v-card-title>
          </v-flex>
        </v-layout>
        <v-divider></v-divider>
        <v-layout row wrap>
          <v-flex xs12 v-for="item in editedInvestigators" v-bind:key="item.objectName">
            {{item.name}}
          </v-flex>
          <v-flex xs12 class="text-xs-center">
            <v-card-text>
              <h3>Current Investigators:</h3>
              <div v-for="item in investigatorsGetter" v-bind:key="item.investigatorID">
                {{ item.investigatorName }}
              </div>
            <!--<v-select
              :items="editedInvestigators"
              v-model="holder"
              item-value="name"
              label="Investigator"
              multiple-line
              bottom
              multiple
            ></v-select> -->
            <v-select
                name="trial.trialInvestigators"
                label="Add Trial Investigators"
                :items="investigators"
                item-value="investigatorId"
                item-text="investigatorName"
                v-model="editedInvestigators"
                id="trial.trialInvestigators"
                multiple
                max-height="400"
                hint="Pick your investigators"
                persistent-hint
              ></v-select>             
            </v-card-text>
            <v-btn depressed class="grey white--text" to="/investigator/new">Create New Investigator</v-btn>
          </v-flex>
        </v-layout>
        <v-divider></v-divider>
        <v-layout row wrap>
          <v-flex xs12>
            <v-card-actions class="justify-center">
              <v-btn depressed class="grey lighten-1 white--text" @click="editDialog = false">Cancel</v-btn>
              <v-btn depressed class="white--text cyan " @click="onSaveChanges">Save</v-btn>
            </v-card-actions>
          </v-flex>
        </v-layout>
      </v-container>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: ['trial'],
  data () {
    return {
      editDialog: false,
      editedInvestigators: this.trial.trialInvestigators,
      trialInvestigators: [],
      holder: []
    }
  },
  computed: {
    investigators () {
      return this.$store.getters.loadedInvestigators
    },
    loadInvestigators () {
      return this.$store.getters.loadedTrials
    },
    investigatorsGetter () {
      if (this.trial.trialInvestigators) {
        var indis = []
        var val = []
        // var item = []
        this.trial.trialInvestigators.filter(function (elem) {
          indis.push(elem)
        })
        console.log('Investigator IDs: ' + JSON.stringify(indis))
        for (let i = 0; i < indis.length; i++) {
          console.log('SECOND GET Investigator: ' + JSON.stringify(this.$store.getters.loadedInvestigator(indis[i])))
          if (this.$store.getters.loadedInvestigator(indis[i])) {
            val.push(this.$store.getters.loadedInvestigator(indis[i]))
          }
        }
        console.log('FINAL val: ' + JSON.stringify(val))
        return val
      } else {
        return null
      }
    }
  },
  methods: {
    onSaveChanges () {
      this.trialInvestigators = this.editedInvestigators
      this.editDialog = false
      console.log('edit page: ' + this.trialInvestigators)
      this.$store.dispatch('updateTrialData', {
        trialId: this.trial.trialId,
        trialInvestigators: this.trialInvestigators
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// EditTrialInvestigatorsDialog.vue?3423174f